import { render } from "./ConfigSettings.vue?vue&type=template&id=32a19fde"
import script from "./ConfigSettings.vue?vue&type=script&lang=js"
export * from "./ConfigSettings.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ConfigSettings.vue?vue&type=style&index=0&id=32a19fde&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__